import { modalController } from '@ionic/vue';
// @ts-ignore
import AppModal from '../molecules/AppModal.vue';

export function useAppModal() {
  const openModal = async ({ title, content, isHtml = false }: { title: string; content: string; isHtml?: boolean }) => {
    const modal = await modalController.create({
      component: AppModal,
      componentProps: {
        title,
        content,
        isHtml,
        initialBreakpoint: 1,
        breakpoints: [1],
        cssClass: 'full-modal',
      },
    });

    await modal.present();
  };

  return { openModal };
}
